import { usePlayerProfileRequestsStore } from '@/stores/playerProfileRequests';
import PlayerProfileRequestsModal from '@/components/Modals/PlayerProfileRequestsModal/PlayerProfileRequestsModal.vue';
import ChangelogFeed from '@/components/ChangelogFeed/ChangelogFeed.vue';

export default {
  name: 'Notifications',
  components: { PlayerProfileRequestsModal, ChangelogFeed },
  emits: ['unread-change', 'open-history'],
  data() { return { requestPlayer: null }; },
  computed: {
    profileRequests() { return usePlayerProfileRequestsStore(); },
  },
  methods: {
    markVisibleAsRead() { this.$refs.feed?.markVisibleAsRead(); },
  },
};
